// extracted by mini-css-extract-plugin
export default {"container":"preloader_container__Ot8lo","loader":"preloader_loader__zG2Kv","App-logo-spin":"preloader_App-logo-spin__q0ate"};